module.exports = __webpack_public_path__ + "static/media/instagram.30bb343e.svg";